// extracted by mini-css-extract-plugin
export default {"root":"Login_root__uRGg0","button_container":"Login_button_container__WnLeM","remember":"Login_remember__SqXbU","link":"Login_link__U-HwZ","signup":"Login_signup__mPCzx"};